import { z } from 'zod';
export const createPlatformConnectionSchema = z.object({
    platform: z.string().min(1).max(20),
    externalId: z.string().max(255).optional(),
    credentials: z.string().optional(),
});
export const updatePlatformConnectionSchema = z.object({
    status: z.enum(['connected', 'disconnected', 'error']).optional(),
    externalId: z.string().max(255).optional(),
    credentials: z.string().optional(),
});
export const createScheduledPublishSchema = z.object({
    episodeId: z.string().uuid(),
    scheduledAt: z.string().datetime(),
});
//# sourceMappingURL=publishing.schemas.js.map